import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "e164",
  standalone: false
})
export class FormatE164Pipe implements PipeTransform {
  // this isn't real e164 formatting but this is how the admin portal did it
  // if we ever change it, consider using the E164Number class in the sip library
  transform(raw: string): any {
    return raw?.length === 11 ? raw.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$1-$2-$3-$4") : raw;
  }
}
